///<reference path="../node_modules/@types/core-js/index.d.ts" />
///<reference path="../node_modules/@types/node/index.d.ts" />
import {platformBrowserDynamic} from "@angular/platform-browser-dynamic";
import { AppModule } from "./app.module";
import { enableProdMode } from "@angular/core";
if ((process.env.ENV && process.env.ENV.trim() === "production") || (process.env.ENV && process.env.ENV.trim() === "iproduction") ) {
    enableProdMode();
}

let bootstrap = true;
if (window.parent && (window.parent as any).AuthenticationContext)
{
    bootstrap = false;
}

if (bootstrap)
{
    const platform = platformBrowserDynamic();
    platform.bootstrapModule(AppModule);
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./App/main.ts